/**
 * Offer letter templates (admin) – template string, status, meta
 */

import { apiClient } from '../client'

export interface OfferLetterTemplate {
  id: number
  template: string | null
  template_ar: string | null
  status: string
  type: 'office_based' | 'field_team' | string
  meta: Record<string, unknown> | null
  created_at: string
  updated_at: string
}

const unwrap = <T>(res: { data?: T }) => res.data

export const offerLetterTemplateRepository = {
  async getAll(): Promise<OfferLetterTemplate[]> {
    const res = await apiClient.get<{ data: OfferLetterTemplate[] }>('/api/offer-letter-templates')
    return Array.isArray(unwrap(res)) ? unwrap(res)! : []
  },

  async getActive(): Promise<OfferLetterTemplate | null> {
    const res = await apiClient.get<{ data: OfferLetterTemplate | null }>('/api/offer-letter-templates/active')
    return unwrap(res) ?? null
  },

  async getActiveByType(type: 'office_based' | 'field_team' | string): Promise<OfferLetterTemplate | null> {
    const res = await apiClient.get<{ data: OfferLetterTemplate | null }>(
      `/api/offer-letter-templates/active?type=${encodeURIComponent(type)}`
    )
    return unwrap(res) ?? null
  },

  async getById(id: number): Promise<OfferLetterTemplate> {
    const res = await apiClient.get<{ data: OfferLetterTemplate }>(`/api/offer-letter-templates/${id}`)
    return unwrap(res)!
  },

  async create(data: {
    template?: string
    template_ar?: string
    status?: string
    type?: 'office_based' | 'field_team' | string
    meta?: Record<string, unknown>
  }): Promise<OfferLetterTemplate> {
    const res = await apiClient.post<{ data: OfferLetterTemplate }>('/api/offer-letter-templates', data)
    return unwrap(res)!
  },

  async update(
    id: number,
    data: {
      template?: string
      template_ar?: string
      status?: string
      type?: 'office_based' | 'field_team' | string
      meta?: Record<string, unknown>
    }
  ): Promise<OfferLetterTemplate> {
    const res = await apiClient.put<{ data: OfferLetterTemplate }>(`/api/offer-letter-templates/${id}`, data)
    return unwrap(res)!
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/offer-letter-templates/${id}`)
  },
}
